















































































































































































































































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { onlyNumber, maskDate, minutesToHours, getWeekdayByDate, getSnackbarMessage } from '@/utils/common'
import { ITriagem, Triagem } from '@/types/implements/Triagem'
import { getModule } from 'vuex-module-decorators'
import { SendReservaSala, PrecaucoesFromTasyTipoEnum, PrecaucoesFromTasy } from '@/types/_'
import BackofficeGlobalStore from '@/components/Backoffice/Store/BackofficeGlobalStore'
import BackofficeAgendamentoStore from '@/components/Backoffice/Store/BackofficeAgendamentoStore'
import ReservaSalaStore from '@/components/ReservaSala/Store/ReservaSalaStore'
import ChatStore from '@/components/Chat/Store/ChatStore'
import EventBus from '@/plugins/EventBus'
import moment from 'moment'
import { buildSurgerySchedulingLimitParams, getInvalidSchedulingDates, isInvalidSchedulingDate } from '@/services/surgery-scheduling-limit.service'
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'
import resourceTimelinePlugin from '@fullcalendar/resource-timeline'
import timeGrid from '@fullcalendar/timegrid'
import ptBrLocale from '@fullcalendar/core/locales/pt-br'
import tippy from 'tippy.js'

@Component({ components: { FullCalendar } })

export default class ComponentModalReservaDeSala extends Vue {
  $refs!: {
    confirmarTriagemForm: any,
    agendamentoChat: any
  }

  templateMessage = {
    icon: 'mdi-close-circle-outline',
    message: 'Ocorreu um erro ao preencher o formulário...',
    color: 'red darken-2',
  }

  guiaCancelada: boolean = false
  errModal: boolean = false
  get guiaCanceladaNaOperadora() { return this.guiaCancelada }
  set guiaCanceladaNaOperadora(value: boolean) { this.guiaCancelada = value }
  get errorModal() { return this.errModal }
  set errorModal(value: boolean) { this.errModal = value }

  confirmarTriagemRule: any = {
    valid: true,
    numeroReserva: [v => !!v || 'O campo n reserva é obrigatório.'],
    salaRules: [v => (!!v && !!v.id) || 'O campo sala da cirurgia é obrigatório.'],
    surgeryDateRules: [v => !!v || 'O campo data da cirurgia é obrigatório.'],
    timerSurgeryRules: [v => !!v || 'O campo tempo da cirurgia é obrigatório.'],
    intervalRoomRules: [v => !!v || 'O campo intervalo pós-cirurgia é obrigatório.'],
    motivoTransferenciaReserva: [v => !!v || 'O campo motivo da reserva é obrigatório.'],
    timeStartRules: [
      v => !!v || 'O campo data da cirurgia é obrigatório.',
      v => this.validaTimeStart(v) || 'O campo data da cirurgia é obrigatório.',
    ],
  }

  triagem: ITriagem = new Triagem()
  calLoading: boolean = false
  loadEquipamentos: boolean = false
  timezone: string = ''
  surgeryDate: string = ''
  timeStart: string = ''
  event: any = {}
  loaderNumeroReserva: boolean = false
  loadConfirmar: boolean = false
  currentDate: any = moment('2021-02-03', 'YYYY-MM-DD').format('YYYY-MM-DD')
  numeroReservaMessage: string = ''
  invalidSchedulingDates: { data: string }[] = []
  surgeryDateInputMenu: boolean = false
  surgeryDateText: string = ''
  loadingRoomInput: boolean = false
  loadingSurgeryCenterInput: boolean = false

  calendarOptions: any = {
    timeZone: 'UTC',
    height: '100%',
    locale: ptBrLocale,
    plugins: [resourceTimelinePlugin, interactionPlugin, dayGridPlugin, timeGrid],
    initialView: 'resourceTimeline',
    aspectRatio: 1.5,
    headerToolbar: {
      left: 'today,prev,next',
      center: 'title',
      right: '',
    },
    slotLabelFormat: { hour12: false, hour: '2-digit', minute: '2-digit' },
    slotDuration: '00:30:00',
    editable: false,
    droppable: false,
    selectable: true,
    resourceAreaHeaderContent: 'Salas',
    resourceOrder: 'title',
    resources: this.getReservaSalasResources,
    eventDidMount: this.eventRender,
    customButtons: {
      prev: {
        text: 'Anterior',
        click: async () => {
          const { calendar }: any = this.$refs
          const dateCurrent = moment(calendar.getApi().getDate()).format('YYYY-MM-DD')
          await this.changeDateResource(dateCurrent)
          calendar.getApi().prev()
        },
      },
      next: {
        text: 'Próximo',
        click: async () => {
          const { calendar }: any = this.$refs
          calendar.getApi().next()
          const dateCurrent = moment(calendar.getApi().getDate()).add(1, 'days').format('YYYY-MM-DD')
          await this.changeDateResource(dateCurrent)
        },
      },
      today: {
        text: 'Hoje',
        click: () => {
          const { calendar }: any = this.$refs
          calendar.getApi().today()
          const dateCurrent = moment().format('YYYY-MM-DD')
          this.changeDateResource(dateCurrent)
        },
      },
    },
  }

  get textFieldProps() {
    return {
      'prepend-icon': 'las la-calendar-alt',
      class: 'edit-hospital-text-grid__input',
    }
  }

  get datePickerProps() {
    return {
      locale: this.$vuetify.lang.current,
      color: 'rgb(38, 82, 163)',
      min: new Date(Date.now()).toISOString(),
    }
  }

  get timePickerProps() {
    return {
      format: '24hr',
      color: 'rgb(38, 82, 163)',
      min: '00:00',
      locale: this.$vuetify.lang.current,
      allowedMinutes: m => m % 15 === 0,
    }
  }

  get roomChecked() {
    return this.getReservaSalaStore.roomChecked
  }

  get surgeryCenter() {
    return this.getReservaSalaStore.surgeryCenter
  }

  get hospitalSelecionado() {
    return this.getReservaSalaStore.hospitalSelecionado
  }

  get getBackofficeGlobalStore() {
    return getModule(BackofficeGlobalStore, this.$store)
  }

  get getReservaSalaStore() {
    return getModule(ReservaSalaStore, this.$store)
  }

  get getChatStore() {
    return getModule(ChatStore, this.$store)
  }

  get getBackofficeAgendamentoStore() {
    return getModule(BackofficeAgendamentoStore, this.$store)
  }

  get showModalReservaDeSala() {
    return this.getBackofficeGlobalStore.modal.reservaDeSala
  }

  set showModalReservaDeSala(val: boolean) {

    if (!val) {
      this.equipmentSelectionConfirmed = false
    }

    this.getBackofficeGlobalStore.setModal({ name: 'reservaDeSala', value: val })
  }

  get calendarLoading() {
    return this.calLoading
  }

  set calendarLoading(val: boolean) {
    this.calLoading = val
  }

  get getCurrentDate() {
    return this.currentDate
  }

  set getCurrentDate(value) {
    this.currentDate = value
  }

  get showModalReservaSala() {
    return this.getReservaSalaStore.modalReservaSala
  }

  set showModalReservaSala(value: boolean) {
    this.getReservaSalaStore.setShowModalReservaSala(value)
  }

  get loadingEquipamentos() {
    return this.loadEquipamentos
  }

  set loadingEquipamentos(value: boolean) {
    this.loadEquipamentos = value
  }

  get motivosTransferenciaReserva() {
    return this.getReservaSalaStore.motivosTransferenciaReserva
  }

  get getReservaSalasResources() {
    return this.getReservaSalaStore.reservaSalasResource
  }

  get getReservaSalasEvents() {
    return this.getReservaSalaStore.reservaSalasEvent
  }

  get loadingConfirmar() {
    return this.loadConfirmar
  }

  set loadingConfirmar(value: boolean) {
    this.loadConfirmar = value
  }

  get loadingNumeroReserva() {
    return this.loaderNumeroReserva
  }

  set loadingNumeroReserva(value: boolean) {
    this.loaderNumeroReserva = value
  }

  get surgeryWeekday() {
    return this.surgeryDate ? getWeekdayByDate(this.surgeryDate) : ''
  }

  get formattedSurgeryDate() {
    return this.surgeryDate ? moment(this.surgeryDate).format('DD/MM/YYYY') : ''
  }

  syncSurgeryDateText() {
    this.surgeryDateText = this.formattedSurgeryDate
  }

  parseSurgeryDateText(value: string) {
    const digits = (value || '').replace(/\D/g, '')

    if (digits.length < 8) return ''

    const parsedDate = moment(digits, 'DDMMYYYY', true)

    return parsedDate.isValid() ? parsedDate.format('YYYY-MM-DD') : ''
  }

  canUseSurgeryDate(date: string) {
    const minimumDate = moment(this.surgeryDateInputProps.min).format('YYYY-MM-DD')

    return date >= minimumDate && this.surgeryDateInputProps.allowedDates(date)
  }

  async onSurgeryDateTextInput(value: string) {
    this.surgeryDateText = value || ''
    const digits = this.surgeryDateText.replace(/\D/g, '')

    if (!digits) {
      this.surgeryDate = ''
      return
    }

    const parsedDate = this.parseSurgeryDateText(value)

    if (!parsedDate) return

    if (!this.canUseSurgeryDate(parsedDate)) {
      EventBus.$emit('setSnackbar', getSnackbarMessage('A data selecionada não é válida para o agendamento dessa cirurgia. Por favor, escolha outra data.', 'error'))
      this.syncSurgeryDateText()
      return
    }

    if (parsedDate === this.surgeryDate) {
      this.syncSurgeryDateText()
      return
    }

    this.surgeryDate = parsedDate
    this.syncSurgeryDateText()
    await this.onChangeSurgeryDate(parsedDate)
  }

  @Watch('surgeryDate')
  onSurgeryDateChangeText() {
    this.syncSurgeryDateText()
  }

  clearSurgeryDate() {
    this.timeStart = ''
    this.surgeryDate = ''
    this.surgeryDateText = ''
    this.surgeryDateInputMenu = false
  }

  eventRender(info: any) {
    if (info.event.extendedProps.dataAgendamentoVirtual) {
      const span = document.createElement('span')
      span.setAttribute('class', 'fa fa-building white--text ml-2')
      info.el.appendChild(span)
    }

    if (info.event.extendedProps.description) {
      tippy(info.el, {
        content: info.event.extendedProps.description,
        placement: 'top',
      })
    }
  }

  validaTimeStart(value) {
    if (value) return true
    return false
  }

  onlyNumberUtil(value) {
    return onlyNumber(value)
  }

  minutesToHoursUtil(value) {
    return minutesToHours(value)
  }

  formatDate(dt) {
    return maskDate(dt)
  }

  loadCaixasCirurgicas: boolean = false

  get loadingCaixasCirurgicas() {
    return this.loadCaixasCirurgicas
  }

  set loadingCaixasCirurgicas(value: boolean) {
    this.loadCaixasCirurgicas = value
  }

  get caixaCirurgicaHabilitada() {
    const { formulario } = this.getBackofficeGlobalStore.template
    if (!formulario.caixaCirurgica) return false
    return formulario.caixaCirurgica.habilitado
  }

  campoHabilitado(prop: string) {
    if (this.getBackofficeGlobalStore.template.formulario) {
      const response = this.getBackofficeGlobalStore.template.formulario[prop]

      if (response) return !!response.habilitado
    }

    return false
  }

  canEditNumeroLeito() {
    return this.getBackofficeGlobalStore.acoes.permiteEditarLeitoDoPaciente
  }

  canEditNumeroAtendimento() {
    return this.getBackofficeGlobalStore.acoes.permiteEditarNumeroDoAtendimentoAoPacienteNoHospital
  }

  // Carrega o catálogo de equipamentos da solicitação e persiste automaticamente
  // os grupos com um único equipamento cadastrado, sem exigir que a pessoa abra
  // o modal "Adicionar Equipamento" manualmente. Assim, a confirmação da reserva
  // só continua bloqueada quando existe uma escolha real a ser feita pelo usuário.
  async resolveEquipamentosAutomaticamente() {
    if (!this.getBackofficeGlobalStore.solicitacao.id) return

    let hospitalId
    const { hospitalId: surgerySolicitationHospitalId } = this.getBackofficeGlobalStore.solicitacao

    if (this.hasHospitalFromNetwork) {
      const { data } = this.hospitalSelecionado
      const { id: hospitalIdFromNetwork } = data

      if (surgerySolicitationHospitalId === hospitalIdFromNetwork) {
        hospitalId = surgerySolicitationHospitalId
      } else {
        hospitalId = hospitalIdFromNetwork
      }
    } else {
      hospitalId = surgerySolicitationHospitalId
    }

    const loadEquipmentRequest = await this.getBackofficeGlobalStore.loadEquipamentos()

    if (loadEquipmentRequest.success) {
      await this.getBackofficeGlobalStore.getEquipmentGroupByHospitalId({ hospitalId, hasHospitalFromNetwork: this.hasHospitalFromNetwork })
      await this.getBackofficeGlobalStore.persistPendingAutoSelectedEquipamentos()
    }

    this.getBackofficeGlobalStore.removeDuplicates()
  }

  async showModalEquipamentos() {
    this.loadingEquipamentos = true

    await this.resolveEquipamentosAutomaticamente()

    this.getBackofficeGlobalStore.setModal({ name: 'equipamentos', value: true })
    this.loadingEquipamentos = false
  }

  async showModalCaixasCirurgicas() {
    this.loadingCaixasCirurgicas = true
    await this.getBackofficeGlobalStore.getAllCaixasCirurgicasByHospitalId()
    this.getBackofficeGlobalStore.setModal({ name: 'caixaCirurgica', value: true })
    this.loadingCaixasCirurgicas = false
  }

  async getSurgeryRoomsAvailabity() {
    if (
      !this.validadeDateStart()
      || !this.getBackofficeGlobalStore.solicitacao.tempoCirurgia
      || !this.getBackofficeGlobalStore.solicitacao.id
    ) {
      return
    }

    this.calendarLoading = true
    const dateChange = moment(this.surgeryDate).format('YYYY-MM-DD')
    const params = {
      solicitacaoId: this.getBackofficeGlobalStore.solicitacao.id,
      data: dateChange,
      hora: this.timeStart || null,
      tempoCirurgia: this.getBackofficeGlobalStore.solicitacao.tempoCirurgia,
    }

    const { calendar }: any = this.$refs
    await calendar.getApi().removeAllEvents()

    const res = await this.getReservaSalaStore.getReservaSalas(params)
    if (res.success) {
      await calendar.getApi().addEventSource(this.getReservaSalaStore.reservaSalasEvent)
      await calendar.getApi().gotoDate(this.surgeryDate)
      await calendar.getApi().render()
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: res.message || 'Ocorreu um erro ao buscar as reservas.', icon: 'warning', color: '#C62828' })
    }

    this.calendarLoading = false
  }

  changeHospital() {
    this.getReservaSalaStore.clearCentrosCirurgicos()
    this.getReservaSalaStore.clearSurgeryCenter()
    this.getReservaSalaStore.clearRoomChecked()

    this.equipmentSelectionConfirmed = false
    this.loadReservaDeSala()
  }

  validadeDateStart() {
    if (!this.surgeryDate) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Data da cirurgia é obrigatório', icon: 'warning', color: '#C62828' })
      return false
    }

    const selectedYear = Number(moment(this.surgeryDate).format('YYYY'))

    if (selectedYear < 2018) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Não existem agendamentos anteriores a 2018', icon: 'warning', color: '#C62828' })
      this.surgeryDate = ''
      return false
    }

    if (selectedYear > 9999) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Data inválida', icon: 'warning', color: '#C62828' })
      this.surgeryDate = ''
      return false
    }

    return true
  }

  async loadReservaDeSala() {
    this.calendarLoading = true
    const dataAgendament = this.getBackofficeGlobalStore.novaDataSolicitada.dataAgendamento ? moment(this.getBackofficeGlobalStore.novaDataSolicitada.dataAgendamento) : moment()
    this.surgeryDate = moment(dataAgendament).format('YYYY-MM-DD')
    this.syncSurgeryDateText()

    if (this.getBackofficeGlobalStore.novaDataSolicitada.dataAgendamento) {
      this.timeStart = moment(dataAgendament).format('HH:mm')
    }

    const params = {
      solicitacaoId: this.getBackofficeGlobalStore.solicitacao.id,
      data: this.surgeryDate,
      hora: this.timeStart,
      tempoCirurgia: this.getBackofficeGlobalStore.solicitacao.tempoCirurgia,
      hospitalId: this.hospitalSelecionado ? this.hospitalSelecionado.data.id : null,
    }

    if (typeof this.getBackofficeGlobalStore.solicitacao.dataAntecedenciaDeInternacao === 'string') {
      this.getBackofficeGlobalStore.solicitacao.dataAntecedenciaDeInternacao = new Date(
        this.getBackofficeGlobalStore.solicitacao.dataAntecedenciaDeInternacao,
      )
    }

    const { calendar }: any = this.$refs
    await calendar.getApi().removeAllEvents()

    const res = await this.getReservaSalaStore.getReservaSalas(params)
    if (res.success) {
      await calendar.getApi().addEventSource(this.getReservaSalaStore.reservaSalasEvent)
      await calendar.getApi().gotoDate(this.surgeryDate)
      await calendar.getApi().render()
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: res.message || 'Ocorreu um erro ao buscar as reservas.', icon: 'warning', color: '#C62828' })
    }

    this.calendarLoading = false
  }

  async changeDateResource(value: string) {
    // Check can't send request withou parameters
    if (
      !this.validadeDateStart()
      || !this.getBackofficeGlobalStore.solicitacao.tempoCirurgia
      || !this.getBackofficeGlobalStore.solicitacao.id
    ) {
      return
    }

    this.calendarLoading = true

    this.surgeryDate = moment(value).format('YYYY-MM-DD')
    this.syncSurgeryDateText()

    const params = {
      solicitacaoId: this.getBackofficeGlobalStore.solicitacao.id,
      data: this.surgeryDate,
      tempoCirurgia: this.getBackofficeGlobalStore.solicitacao.tempoCirurgia,
    }

    const { calendar }: any = this.$refs
    await calendar.getApi().removeAllEvents()

    const res = await this.getReservaSalaStore.getReservaSalas(params)
    if (res.success) {
      await calendar.getApi().addEventSource(this.getReservaSalaStore.reservaSalasEvent)
      calendar.getApi().render()
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: res.message || 'Ocorreu um erro ao buscar as reservas.', icon: 'warning', color: '#C62828' })
    }

    this.calendarLoading = false
  }

  async renderCalendarEvents() {
    if (this.surgeryDate) {
      const { calendar }: any = this.$refs
      await calendar.getApi().removeAllEvents()
      await calendar.getApi().addEventSource(this.getReservaSalaStore.reservaSalasEvent)
      await calendar.getApi().gotoDate(this.surgeryDate)
      await calendar.getApi().render()
    }
  }

  get selectedHospitalFromNetwork() {
    const { data } = this.getReservaSalaStore.hospitalSelecionado

    if (data) {
      return {
        name: data.nome,
        id: data.id,
      }
    }

    return null
  }

  async confirmar() {
    this.loadingConfirmar = true
    let solicitacaoId = this.getBackofficeGlobalStore.solicitacao.id

    const { hospitalId: surgerySolicitationHospitalId } = this.getBackofficeGlobalStore.solicitacao

    if (this.hasHospitalFromNetwork && (this.selectedHospitalFromNetwork && this.selectedHospitalFromNetwork.id !== surgerySolicitationHospitalId) && !this.equipmentSelectionConfirmed) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Para prosseguir é necessário verificar os equipamentos da solicitação', icon: 'warning', color: '#C62828' })

      this.loadingConfirmar = false

      return
    }

    let isValid: boolean = true

    if (this.getBackofficeGlobalStore.solicitacao.hospital
      && this.getBackofficeGlobalStore.solicitacao.hospital.exigeNumeroReserva) {
      const { numeroAgendamento } = this.getReservaSalaStore.reservaSalaInfo
      isValid = await this.checkNumeroReserva(numeroAgendamento)
    }

    const isValidCheckNumeroReserva = this.$refs.confirmarTriagemForm.validate()

    if (isValid && isValidCheckNumeroReserva) {
      // Send messages from chat
      if (this.$refs.agendamentoChat.getMensagem) {
        this.$refs.agendamentoChat.send()
      }

      const tempoCirurgia = this.getBackofficeGlobalStore.solicitacao.tempoCirurgia || ''

      const { calendar }: any = this.$refs
      calendar.getApi().gotoDate(this.surgeryDate)

      const dataInicio = moment(`${this.surgeryDate} ${this.timeStart}`, 'YYYY-MM-DD HH:mm').format('YYYY-MM-DDTHH:mm')
      const dataFim = moment(`${this.surgeryDate} ${this.timeStart}`, 'YYYY-MM-DD HH:mm').minutes(parseInt(tempoCirurgia.toString(), 10)).format('YYYY-MM-DDTHH:mm')

      const params: SendReservaSala = {
        solicitacaoId: this.getBackofficeGlobalStore.solicitacao.id,
        salaId: this.getReservaSalaStore.roomChecked.data.id,
        centroCirurgicoId: this.getReservaSalaStore.surgeryCenter.data.id,
        numeroAgendamento: this.getReservaSalaStore.reservaSalaInfo.numeroAgendamento,
        dataAgendamentoVirtual: this.getReservaSalaStore.reservaSalaInfo.dataAgendamentoVirtual || false,
        motivoTransferenciaReservaId: this.getReservaSalaStore.reservaSalaInfo.motivoTransferenciaReservaId,
        tempoCirurgia: +tempoCirurgia,
        data: this.surgeryDate,
        hora: this.timeStart,
        inicio: dataInicio,
        fim: dataFim,
      }

      Object.entries(params).forEach(([key, value]) => {
        if (['', null, undefined].includes(value as any)) {
          delete params[key]
        }
      })

      const retornaObjeto = await this.getReservaSalaStore.getTipoObjetoPost(params)

      const pacienteInternadoPayload = {
        numeroDoLeitoDoPacienteInternado: this.getBackofficeGlobalStore.solicitacao.numeroDoLeitoDoPacienteInternado || '',
        numeroDoAtendimentoAoPacienteNoHospital: this.getBackofficeGlobalStore.solicitacao.numeroDoAtendimentoAoPacienteNoHospital || '',
      }

      Object.entries(pacienteInternadoPayload).forEach(([key, value]) => {
        if (['', null, undefined].includes(value as any)) {
          delete pacienteInternadoPayload[key]
        }
      })

      const { dataAntecedenciaDeInternacao } = this.getBackofficeGlobalStore.solicitacao

      const response = await this.triagem.backofficeAgendamentoAlteraReserva(params.solicitacaoId, {
        ...retornaObjeto,
        ...pacienteInternadoPayload,
        ...(dataAntecedenciaDeInternacao ? { dataAntecedenciaDeInternacao: moment(dataAntecedenciaDeInternacao).format('YYYY-MM-DDTHH:mm:ss') }
          : {}),
      })

      if (response.success) {
        this.getReservaSalaStore.deleteReservaSalaEvent(solicitacaoId)
        this.getBackofficeGlobalStore.setNovaDataAgendamento(`${this.surgeryDate}T${this.timeStart}`)

        if (this.getBackofficeGlobalStore.mapaCirurgicoAlterarReserva) {
          EventBus.$emit('updateItensMapaCirurgico', true)
        } else if (this.getBackofficeGlobalStore.mapaCirurgicoGradeAlterarReserva) {
          EventBus.$emit('updateItensMapaCirurgicoGrade', true)
        } else {
          await this.getBackofficeAgendamentoStore.loadAgendamentosMedicoSearch(solicitacaoId)
        }

        EventBus.$emit('setSnackbar', { show: true, text: `Reserva alterada com sucesso. ${String.fromCodePoint(0x1F642)}`, icon: 'done', color: '#2E7D32' })
        this.showModalReservaDeSala = false
      } else {
        EventBus.$emit('setSnackbar', { show: true, text: response.message ? `${response.message} ${String.fromCodePoint(0x1F615)}` : `Ocorreu um problema com essa requisição. ${String.fromCodePoint(0x1F615)}`, icon: 'warning', color: '#C62828' })
      }
    }
    solicitacaoId = ''

    this.equipmentSelectionConfirmed = false
    this.loadingConfirmar = false
  }

  async checkNumeroReserva(numeroReserva: string) {
    this.loadingNumeroReserva = true
    if (numeroReserva) {
      const params: any = {
        solicitacaoId: this.getBackofficeGlobalStore.solicitacao.id,
        numeroReserva,
        hospitalId: this.getBackofficeGlobalStore.solicitacao.hospitalId,
      }

      const response = await this.triagem.getCheckNumeroReserva(params)
      this.loadingNumeroReserva = false
      if (!response.success) {
        this.numeroReservaMessage = ''
        EventBus.$emit('setSnackbar', { show: true, text: 'Houve um erro na validação no número de reserva.', icon: 'warning', color: '#C62828' })
        return false
      }

      if (response.success && response.data) {
        EventBus.$emit('setSnackbar', { show: true, text: 'Número de reserva duplicado.', icon: 'warning', color: '#C62828' })
        this.numeroReservaMessage = 'Número de reserva duplicado.'
        return false
      }

      this.numeroReservaMessage = ''
      return true
    }

    this.numeroReservaMessage = 'O campo número de reserva é obrigatório.'
    this.loadingNumeroReserva = false
    return false
  }

  get hospitalNome() {
    if (this.getBackofficeGlobalStore.template
      && this.getBackofficeGlobalStore.template.hospital
      && this.getBackofficeGlobalStore.template.hospital.nome) return this.getBackofficeGlobalStore.template.hospital.nome
    return ''
  }

  confereCamposParaDesfazerCancelamento() {
    const errors: string[] = []
    const { numeroAgendamento, dataAgendamentoVirtual } = this.getReservaSalaStore.reservaSalaInfo
    const { tempoCirurgia } = this.getBackofficeGlobalStore.solicitacao
    const { dataVirtualFazReservaDeSala } = this.getReservaSalaStore.configuracoes

    const ERROR_DATA = 'É necessário informar uma data da cirurgia.'
    const ERROR_DATA_FUTURA = 'É necessário escolher uma data futura.'
    const ERROR_SALA = 'É necessário informar a sala.'
    const ERROR_HORARIO = 'É necessário informar um horário.'
    const ERROR_TEMPO_CIRURGIA = 'É necessário informar um tempo de cirugia.'
    const ERROR_NUMERO_RESERVA = 'É necessário informar um número de reserva.'

    if (['', null, undefined].includes(this.surgeryDate)) {
      errors.push(ERROR_DATA)
    } else {
      const diff = moment(new Date().toISOString()).diff(moment(new Date(this.surgeryDate).toISOString()))
      if (moment.duration(diff).asDays() > 0) errors.push(ERROR_DATA_FUTURA)
    }

    if (['', null, undefined].includes(this.roomChecked.data as any) || !this.roomChecked.data.id) errors.push(ERROR_SALA)
    if (['', null, undefined].includes(this.timeStart)) errors.push(ERROR_HORARIO)
    if (['', 0, null, undefined].includes(tempoCirurgia)) errors.push(ERROR_TEMPO_CIRURGIA)
    if (this.getBackofficeGlobalStore.solicitacao.hospital && this.getBackofficeGlobalStore.solicitacao.hospital.exigeNumeroReserva) {
      if (['', null, undefined].includes(numeroAgendamento)) errors.push(ERROR_NUMERO_RESERVA)
    }

    if (dataAgendamentoVirtual && !dataVirtualFazReservaDeSala) {
      const errorsToBeRemoved = [ERROR_SALA, ERROR_HORARIO, ERROR_TEMPO_CIRURGIA, ERROR_NUMERO_RESERVA]
      errorsToBeRemoved.forEach((error: string) => {
        if (errors.includes(error)) {
          errors.splice(errors.indexOf(error), 1)
        }
      })
    }

    return errors
  }

  async backofficeAgendamentoDesfazCancelamento() {
    this.loadingConfirmar = true

    if (this.confereCamposParaDesfazerCancelamento().length > 0) {
      this.errorModal = true
    } else {
      const params: any = {
        salaId: this.roomChecked.data.id,
        centroCirurgicoId: this.getReservaSalaStore.surgeryCenter.data.id,
        solicitacaoId: this.getBackofficeGlobalStore.solicitacao.id,
        numeroAgendamento: this.getReservaSalaStore.reservaSalaInfo.numeroAgendamento,
        dataAgendamentoVirtual: this.getReservaSalaStore.reservaSalaInfo.dataAgendamentoVirtual,
        data: new Date(this.surgeryDate).toISOString(),
        hora: this.timeStart,
        tempoCirurgia: this.getBackofficeGlobalStore.solicitacao.tempoCirurgia,
      }

      const retornaObjeto: any = await this.getReservaSalaStore.getTipoObjetoPost(params)
      retornaObjeto.solicitacaoId = this.getBackofficeGlobalStore.solicitacao.id
      retornaObjeto.guiaCanceladaNaOperadora = this.guiaCanceladaNaOperadora

      const request = await this.getBackofficeGlobalStore.backofficeAgendamentoDesfazCancelamento(retornaObjeto)

      if (request.success) {
        EventBus.$emit('setSnackbar', { show: true, text: `Cancelamento desfeito com sucesso. ${String.fromCodePoint(0x1F642)}`, icon: 'done', color: '#2E7D32' })
        this.showModalReservaDeSala = false
      } else {
        EventBus.$emit('setSnackbar', { show: true, timeout: 10000, text: request.message ? `${request.message} ${String.fromCodePoint(0x1F615)}` : `Ocorreu um problema ao desfazer o cancelamento. ${String.fromCodePoint(0x1F615)}`, icon: 'warning', color: '#C62828' })
      }
    }

    this.loadingConfirmar = false
  }

  @Watch('errorModal')
  onChangeErrorModal(value) {
    //
  }

  @Watch('showModalReservaDeSala')
  async onModalOpen(opened) {
    let solicitacaoId = this.getBackofficeGlobalStore.solicitacao.id

    if (opened) {
      await this.loadReservaDeSala()
      await this.refreshInvalidSchedulingDates()
      await this.resolveEquipamentosAutomaticamente()
    } else {
      await this.getBackofficeGlobalStore.desbloquearSolicitacao(this.getBackofficeGlobalStore.solicitacao.id)
      this.getBackofficeGlobalStore.clearSolicitacao()
      this.getBackofficeGlobalStore.setMapaCirurgicoAlterarReserva(false)

      this.getChatStore.clearAlteracaoDataAgendamentoMensagens()
      this.$refs.confirmarTriagemForm.resetValidation()
      this.$refs.confirmarTriagemForm.reset()

      this.getReservaSalaStore.clearReservaSalasResource()
      this.getReservaSalaStore.clearReservaSalaEvent()
      this.getReservaSalaStore.clearPrecaucoesFromTasy()
      this.getReservaSalaStore.clearSurgeryCenter()
      this.getReservaSalaStore.clearRoomChecked()
      this.getReservaSalaStore.clearCentrosCirurgicos()
      this.getReservaSalaStore.clearHospitalSelecionado()
      this.getReservaSalaStore.clearHospitaisRede()

      if (this.getBackofficeGlobalStore.desfazCancelamento) {
        await this.getBackofficeAgendamentoStore.loadAgendamentosMedicoSearch(solicitacaoId)
        this.getBackofficeGlobalStore.setDesfazCancelamento(false)
        this.loadingConfirmar = false
        this.guiaCanceladaNaOperadora = false
      }

      this.clearSurgeryDate()
    }

    solicitacaoId = ''
    this.numeroReservaMessage = ''
  }

  get equipmentSelectionConfirmed() {
    return this.getBackofficeGlobalStore.equipmentSelectionConfirmed
  }

  set equipmentSelectionConfirmed(confirmed: boolean) {
    this.getBackofficeGlobalStore.setEquipmentSelectionConfirmation(confirmed)
  }

  get hasHospitalFromNetwork() {
    return this.getReservaSalaStore.hospitaisRede.length > 0
  }

  get precaucoesFromTasyAlergias() {
    const { precaucoesFromTasy } = this.getReservaSalaStore
    return precaucoesFromTasy && precaucoesFromTasy.length > 0
      ? precaucoesFromTasy.filter((obj: PrecaucoesFromTasy) => obj.tipo === PrecaucoesFromTasyTipoEnum.ALERGIA)
      : []
  }

  get precaucoesFromTasyPrecaucoes() {
    const { precaucoesFromTasy } = this.getReservaSalaStore
    return precaucoesFromTasy && precaucoesFromTasy.length > 0
      ? precaucoesFromTasy.filter((obj: PrecaucoesFromTasy) => obj.tipo === PrecaucoesFromTasyTipoEnum.PRECAUCAO)
      : []
  }

  get surgeryDateInputProps() {
    const invalidSchedulingDates = this.invalidSchedulingDates.reduce((dateMap, item) => {
      dateMap[item.data] = true
      return dateMap
    }, {})

    const todayDate = new Date(Date.now())
    todayDate.setMonth(todayDate.getMonth() - 3)

    return {
      min: todayDate.toISOString(),
      allowedDates: date => !invalidSchedulingDates[date],
    }
  }

  async onChangeSurgeryDate(date: string) {
    this.surgeryDate = date
    this.syncSurgeryDateText()
    this.surgeryDateInputMenu = false

    await this.getSurgeryRoomsAvailabity()
  }

  async refreshInvalidSchedulingDates() {
    const params = buildSurgerySchedulingLimitParams({
      shouldCheck: !!this.getBackofficeGlobalStore.solicitacao.acoes.verificaLimitadorDeCirurgia,
      hospitalId: this.getBackofficeGlobalStore.solicitacao.hospitalId,
      complexity: this.getBackofficeGlobalStore.solicitacao.complexidade,
      roomId: this.roomChecked.data.id,
      surgeryCenterId: this.surgeryCenter.data.id,
    })

    if (!params) return

    this.invalidSchedulingDates = await getInvalidSchedulingDates(params)

    if (isInvalidSchedulingDate(this.invalidSchedulingDates, this.surgeryDate)) {
      EventBus.$emit('setSnackbar', getSnackbarMessage('A data selecionada não é válida para o agendamento dessa cirurgia. Por favor, escolha outra data.', 'error'))

      this.surgeryDate = ''
    }
  }

  async virtualDateChange() {
    if (this.canShowSurgeryCenterReservation) {
      await this.getReservaSalaStore.clearRoomChecked()
      await this.getReservaSalaStore.updateReservaSalaResource()
      await this.renderCalendarEvents()
    }
  }

  async onSurgeryCenterChange() {
    try {
      this.loadingSurgeryCenterInput = true

      await this.getReservaSalaStore.clearRoomChecked()
      await this.getReservaSalaStore.updateReservaSalaResource()

      if (this.surgeryCenter.data.id) {
        await this.refreshInvalidSchedulingDates()
      }
    } catch (error) {
      console.log('error', error)
      EventBus.$emit('setSnackbar', getSnackbarMessage('Erro ao processar Centro Cirúrgico', 'error'))
    } finally {
      this.loadingSurgeryCenterInput = false
    }
  }

  async onRoomChange() {
    try {
      this.loadingRoomInput = true

      if (this.roomChecked.data.id) {
        await this.refreshInvalidSchedulingDates()
      }
    } catch (error) {
      EventBus.$emit('setSnackbar', getSnackbarMessage('Erro ao processar Sala', 'error'))
    } finally {
      this.loadingRoomInput = false
    }
  }

  get canShowSurgeryCenterReservation() {
    return this.getReservaSalaStore.centrosCirurgicos.length > 0
  }

  get canSurgeryCenterShowRoomField() {
    return this.getReservaSalaStore.configuracoes.dataVirtualFazReservaDeSala || !this.getReservaSalaStore.reservaSalaInfo.dataAgendamentoVirtual
  }

  get canShowGridTime() {
    return this.getReservaSalaStore.configuracoes.dataVirtualFazReservaDeSala || !this.getReservaSalaStore.reservaSalaInfo.dataAgendamentoVirtual
  }

  get canShowMotivoTranferenciaField() {
    return this.getReservaSalaStore.configuracoes.informaMotivoTransferenciaReserva
  }

  get getDisplayPreReserva() {
    return !this.getReservaSalaStore.configuracoes.dataVirtualFazReservaDeSala && this.getReservaSalaStore.reservaSalaInfo.dataAgendamentoVirtual
  }

  displayValidadeDaAutorizacao(date: string = '') {
    const diferencaDaDataDeValidade = new Date().setHours(0, 0, 0, 0) - new Date(date).getTime()
    if (diferencaDaDataDeValidade > 0) {
      return {
        color: 'error',
        icon: 'warning',
        class: 'blink',
        message: `A senha de autorização válida até ${this.formatDate(date)} está <b>VENCIDA</b>.`,
      }
    }

    if (diferencaDaDataDeValidade === 0) {
      return {
        color: 'warning',
        icon: 'priority_high',
        class: 'blink',
        message: `O prazo de validade desta senha se encerra hoje: ${this.formatDate(date)}`,
      }
    }

    return {
      color: 'info',
      icon: 'check_circle',
      class: '',
      message: `A senha de autorização é válida até ${this.formatDate(date)}`,
    }
  }
}

